// extracted by mini-css-extract-plugin
export default {"chip":"chip_chip__s1FPH","activeChip":"chip_activeChip__PFe12"};